import { useContext, createContext } from 'react';

export const CreatePostContext = createContext(null);

export function useCreatePostContext() {
  return useContext(CreatePostContext);
}
